import React from 'react';
import { Box } from '@chargify/custom-ui-components';

import { DetailRow } from '../DetailRow';
import { useTranslation } from 'react-i18next';

export type Props = {
  /**
   * Trial expiration Date
   */
  trialExpirationDate: string;
};

const TrialExpired = ({ trialExpirationDate }: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);

  return (
    <Box marginTop={5}>
      <DetailRow
        label={{
          value: t('subscription_details.expiration_date'),
        }}
        value={{
          value: trialExpirationDate,
          color: 'black.main',
          fontWeight: 0,
        }}
      />
    </Box>
  );
};

export default TrialExpired;
